module.exports = __webpack_public_path__ + "static/graphql-banner-771d02dce87b6282bbd1eab221fba366.png";